function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.4
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  width: 22,
  height: 22,
  fill: "#F4F7F9"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 2.23633C6.16037 2.23633 2.23684 6.15985 2.23684 10.9995C2.23684 12.5465 2.64137 13.9979 3.34526 15.2598L2.25531 19.162C2.15584 19.5173 2.48316 19.8451 2.83889 19.7456L6.743 18.6561C8.00394 19.3586 9.45437 19.7626 11 19.7626C15.8396 19.7626 19.7632 15.8391 19.7632 10.9995C19.7632 6.15985 15.8396 2.23633 11 2.23633Z",
  stroke: "#122443",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 9H15",
  stroke: "#122443",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7 13H11",
  stroke: "#122443",
  strokeLinecap: "round"
}));

function SvgIcDialog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDialog);
export default __webpack_public_path__ + "static/media/ic-dialog.bf2f39a2.svg";
export { ForwardRef as ReactComponent };